import { useCallback } from "react";
import { progressStore, useProgress } from "../lib/store";

import { type Lang } from "./lang";

export { isLang, locale, pick, type L, type Lang } from "./lang";

export const LANGS: { id: Lang; label: string; short: string }[] = [
  { id: "vi", label: "Tiếng Việt", short: "VI" },
  { id: "en", label: "English", short: "EN" },
];

/** Ngôn ngữ hiện tại — dùng ngoài React (toast, tiêu đề phiên…). */
export function currentLang(): Lang {
  return progressStore.get().lang;
}

export function setLang(lang: Lang): void {
  progressStore.update((p) => (p.lang === lang ? p : { ...p, lang }));
}

export function useLang(): Lang {
  return useProgress().lang;
}

export type T = (vi: string, en: string) => string;

/** `t("Xin chào", "Hello")` — chuỗi giao diện đặt ngay tại chỗ dùng, dễ rà soát cả hai ngôn ngữ. */
export function useT(): T {
  const lang = useLang();
  return useCallback((vi: string, en: string) => (lang === "en" ? en : vi), [lang]);
}
